module.exports = __webpack_public_path__ + "img/location-icon.aac99914.svg";